export function slugify(str: string): string {
  return str
    .toLowerCase()
    .normalize("NFD")                // split accented chars
    .replace(/[\u0300-\u036f]/g, "") // remove accents
    .replace(/[^a-z0-9\s-]/g, "")    // remove invalid chars
    .trim()
    .replace(/\s+/g, "-")            // spaces → dash
    .replace(/-+/g, "-");            // collapse dashes
}
